import React, { useState } from 'react';
import { Table, Button, Container, Row, Col, FormControl } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle } from 'react-bootstrap-icons';
import axios from 'axios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-toastify/dist/ReactToastify.css';
import './UsersTable.css';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

const UsersTable = ({ users, setUsers }) => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [buttonStates, setButtonStates] = useState(() =>
    users.reduce((acc, user) => {
      acc[user.id] = { vCard: false, nfc: false, print: false, completed: false };
      return acc;
    }, {})
  );

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleShowBusinessCard = (userId) => {
    navigate(`/user/${userId}`);
  };

  const handleNFCWrite = async (userId) => {
    const url = `http://moka.gercekisler.com/user/${userId}`;

    try {
      const response = await axios.post('http://localhost:5002/write_to_nfc', { url });
      console.log(response.data.message);
      setButtonStates(prev => ({ ...prev, [userId]: { ...prev[userId], nfc: true } }));
      toast.success('NFC yazma işlemi başarılı!');
    } catch (error) {
      console.error('There was an error writing to the NFC card!', error);
      toast.error('NFC yazma işleminde hata oluştu!');
    }
  };

  const handleUserDetail = (userId) => {
    navigate(`/${userId}`);
  };

  const handleUpdateStatus = async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { status: 'completed' });

      setUsers(prevUsers =>
        prevUsers.map(u => (u.id === userId ? { ...u, status: 'completed' } : u))
      );
      setButtonStates(prev => ({
        ...prev,
        [userId]: { ...prev[userId], completed: true }
      }));
      toast.success('User updated successfully');
    } catch (error) {
      console.error('There was an error updating the status!', error);
      toast.error('Error updating user status');
    }
  };

  const handleUndoStatus = async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, { status: 'in-progress' }); // veya dilediğiniz varsayılan durumu kullanın

      setUsers(prevUsers =>
        prevUsers.map(u => (u.id === userId ? { ...u, status: 'in-progress' } : u))
      );
      setButtonStates(prev => ({
        ...prev,
        [userId]: { ...prev[userId], completed: false }
      }));
      toast.success('User status reverted to in-progress');
    } catch (error) {
      console.error('Error reverting user status!', error);
      toast.error('Error reverting user status');
    }
  };

  const filteredUsers = users.filter(user => {
    const userName = `${user.first_name} ${user.last_name}`.toLowerCase();
    const createdAt = user.createdAt ? new Date(user.createdAt.seconds * 1000) : null;
    return (
      userName.includes(searchTerm.toLowerCase()) &&
      (!startDate || !createdAt || createdAt >= startDate) &&
      (!endDate || !createdAt || createdAt <= endDate)
    );
  });

  // Oluşturulma tarihine göre (yeni -> eski) sıralama
  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const aSec = a.createdAt?.seconds || 0;
    const bSec = b.createdAt?.seconds || 0;
    return bSec - aSec;
  });

  return (
    <Container fluid className="users-table-container">
      <Row className="mb-3 align-items-center">
        <Col md={4}>
          <FormControl
            type="text"
            placeholder="Search Users"
            className="search-input"
            value={searchTerm}
            onChange={handleSearch}
          />
        </Col>
        <Col md={3}>
          <DatePicker
            selected={startDate}
            onChange={date => setStartDate(date)}
            className="date-picker"
            placeholderText="Start Date"
            isClearable
            dateFormat="dd/MM/yyyy"
          />
        </Col>
        <Col md={3}>
          <DatePicker
            selected={endDate}
            onChange={date => setEndDate(date)}
            className="date-picker"
            placeholderText="End Date"
            isClearable
            dateFormat="dd/MM/yyyy"
          />
        </Col>

        {/* <Col md={2} className="text-end">
          <p className="users-count">Total Users: {sortedUsers.length}</p>
        </Col> */}
      </Row>
      <Table responsive bordered hover variant="dark" className="users-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Count</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map(user => (
            <tr key={user.id} onClick={() => handleUserDetail(user.id)} style={{ cursor: 'pointer' }}>
              <td>{user.first_name} {user.last_name}</td>
              <td>{user.email}</td>
              <td>{user.status}</td>
              <td>{user.urlVisits}</td>
              <td className="actions-column">
                <Button
                  variant="primary"
                  onClick={e => { e.stopPropagation(); handleShowBusinessCard(user.id); }}
                >
                  Show Card
                </Button>
                <Button
                  variant="secondary"
                  onClick={e => { e.stopPropagation(); handleNFCWrite(user.id); }}
                >
                  Write to NFC {buttonStates[user.id]?.nfc && <CheckCircle style={{ marginLeft: 5 }} />}
                </Button>
                {user.status !== 'completed' ? (
                  <Button
                    variant="info"
                    onClick={e => { e.stopPropagation(); handleUpdateStatus(user.id); }}
                  >
                    Mark Completed {buttonStates[user.id]?.completed && <CheckCircle style={{ marginLeft: 5 }} />}
                  </Button>
                ) : (
                  <Button
                    variant="warning"
                    onClick={e => { e.stopPropagation(); handleUndoStatus(user.id); }}
                  >
                    Undo Completed <XCircle style={{ marginLeft: 5 }} />
                  </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default UsersTable;
